import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-filter-icon',
  templateUrl: './text-filter.component.html'
})
export class TextFilterComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
